import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ExternalUsersManagementRouter } from './external-users-management.router';
import { reducers } from './state/external-users-management.selectors';


@NgModule({
  imports: [
    ExternalUsersManagementRouter,
    StoreModule.forFeature('externalManagement', reducers),
  ],
  declarations: []
})
export class ExternalUsersManagementScreenModule { }